<template>
    <van-tabs class="data-cnt" v-model:active="tabActive" color="#07c160">
      <van-tab name="desc" title="数据说明">
        <article id="content" class="article-content" tabindex="0" style="outline-style: none;">
          <div class="ne-doc-major-viewer">
              <div class="yuque-doc-content" data-df="lake" style="position: relative;">
                  <div>
                      <div class="ne-viewer lakex-yuque-theme-light ne-typography-classic ne-paragraph-spacing-relax ne-viewer-layout-mode-fixed"
                           data-viewer-mode="normal" id="u5f1b">
                          <div class="ne-viewer-body">
                            <ne-oli index-type="0" v-for="(scene,index) in sceneOptions" :key="index">
                              <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"
                                              style="color: rgb(0, 0, 0);"><span>{{index+1}}</span></span></ne-oli-i>
                              <ne-oli-c class="ne-oli-content" id="ub05c2e9a" data-lake-id="ub05c2e9a">
                                <ne-text id="u57cc81b8" ne-bold="true" style="color: rgb(0, 0, 0);">{{ scene.text }}:</ne-text>
                                <ne-text id="u62ed35b1" style="color: rgb(0, 0, 0);">{{scene.gifts.join("-")}}礼物的数量(括号内为所有飘屏人民币总价值),出{{scene.resetNum}}个{{scene.gifts[0]}}之后数据重置</ne-text>
                                <span class="ne-viewer-b-filler" ne-filler="block"><br></span></ne-oli-c>
                            </ne-oli>
                            <ne-oli index-type="0">
                              <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"><span>{{sceneOptions.length+1}}</span></span>
                              </ne-oli-i>
                              <ne-oli-c class="ne-oli-content" id="ud42ae12e" data-lake-id="ud42ae12e">
                                <ne-text id="ua05cf6fe" ne-bold="true" style="color: rgb(0, 0, 0);display:flex;"><ClipbordComponent :show-content="true" btn-text="QQ群号复制" :text="qqGroupId" show-copy-button="true"/></ne-text>
                                <span class="ne-viewer-b-filler" ne-filler="block"></span></ne-oli-c>
                            </ne-oli>
                            <ne-oli v-if="downloadUrl" index-type="0">
                              <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"><span>{{sceneOptions.length+2}}</span></span>
                              </ne-oli-i>
                              <ne-oli-c class="ne-oli-content" id="ud42ae12e" data-lake-id="ud42ae12e">
                                <ne-text id="ua05cf6fe" ne-bold="true" style="color: rgb(0, 0, 0);display:flex;">
                                  <ClipbordComponent :show-content="true" :btn-text="`${platformName}下载地址`" :text="downloadUrl" show-copy-button="true"/>
                                  <span>&nbsp;&nbsp;<a target="_blank" :href="downloadUrl"><van-button size="small" type="primary">下载</van-button></a></span>
                                </ne-text>

                              </ne-oli-c>
                            </ne-oli>
                          </div>
                          <div class="ne-inner-overlay-container">
                              <ne-overlay-tmp contenteditable="false" data-event-boundary="overlay">
                                  <div class="count-tips-module_tipsContainer___5agc"></div>
                              </ne-overlay-tmp>
                          </div>
                      </div>
                      <div style="height: 0px; overflow: hidden;"></div>
                  </div>
              </div>
          </div>
        </article>
      </van-tab>
      <van-tab name="query" title="数据查询">
        <van-dropdown-menu>
          <van-dropdown-item v-model="queryType" :options="queryOptions"/>
          <van-dropdown-item v-model="sceneTye" :options="sceneOptions" />
        </van-dropdown-menu>
        <van-search v-if="queryType==='gift'"
            v-model="searchKeyword"
            show-action
            placeholder="请输入礼物名称或价值"
                    @search="doQueryData"
        ><template #action>
          <div style="display:flex;">
            <van-checkbox size="small" v-model="filterSmallVal">过滤边角料</van-checkbox>
            <van-button type="primary" size="small" @click="doQueryData">搜索</van-button>
          </div>
        </template>
        </van-search>
        <ul v-if="user.maxtMemberAuth">
          <li class="gift-record" v-for="(record,index) in pageData.items" :key="index">
            <div class="gift-user" v-if="queryType==='gift'">{{record.user}}</div>
            <div class="gift-time">{{record.time}}</div>
            <div class="gift-name" v-if="queryType==='gift'">{{record.giftName + "(" + record.val + ")"}}x{{record.num}}</div>
            <div class="gift-scene" v-if="queryType==='history'">{{sceneMap[record.scenne]}}</div>
            <div class="gift-data" v-if="queryType==='history'">{{record.msg}}</div>
          </li>
        </ul>
        <div v-else>
          <p class="van-color-danger">数据查询功能为白银会员专享<router-link to="/pay">
            <van-button size="small" type="danger">购买会员</van-button>
          </router-link></p>
        </div>

        <van-pagination v-model="currentPage" :show-page-size="3"
                        force-ellipses :total-items="pageData.totalCount"
                        :items-per-page="pageData.pageSize" />
      </van-tab>
      <van-tab name="broadcast" title="数据机器人" badge="新">
        <div class="content-wrap">
          <div class="line-text" v-if="!supportRobot">
            <span class="text-danger">{{platformName}}数据机器人正在开发中，需要加急请联系客服(QQ群:{{qqGroupId}})。</span>
          </div>
          <div class="line-text">
            <div class="line-label">说明:</div>
            <div class="line-content">在聊天室公屏播报奖池数据。</div>
          </div>

          <div class="line-text">
            <div class="line-label">到期时间:</div>
            <div class="line-content">{{robotConfig.expire}}</div>
          </div>
          <div class="line-text">
            <div class="line-label">数据状态:</div>
            <div class="line-content">
              <template v-if="robotConfig.realStatus===true">
                <van-icon color="#07c160" name="passed" />
              </template>

              <template v-else-if="robotConfig.realStatus===false">
                <van-icon color="#FF4081" name="close" />
                <span class="text-danger" v-if="!robotConfig.status">推送开关关闭</span>
                <template v-else>
                  <span class="line-content" v-if="robotConfig.expire < format(new Date(), 'yyyy-MM-dd hh:mm:ss')"><span class="text-danger">授权已过期</span></span>
                </template>
              </template>
            </div>
          </div>
          <div class="line-text">
            <div class="line-label">推送开关:</div>
            <div class="line-content">
              <template v-if="robotConfig.status===true">
                <van-icon color="#07c160" name="passed" />
              </template>

              <template v-else-if="robotConfig.status===false">
                <van-icon color="#FF4081" name="close" />
              </template>
            </div>
          </div>
          <div class="line-text">
            <div class="line-label">播报房间ID:</div>
            <div class="line-content">
              <van-tag type="info" :plain="false" v-if="robotConfig.room">{{robotConfig.room}}</van-tag>
              <span v-else>-</span>
            </div>
          </div>
          <div class="line-text">
            <div class="line-label">播报玩法:</div>
            <div class="line-content">
              <div class="game-list" v-if="robotConfig.games && robotConfig.games.length > 0">
                <van-tag type="info" :plain="false" v-for="gameName in robotConfig.games" :Key="gameName">{{ gameName }}</van-tag>
              </div>
              <span v-else>-</span>
            </div>
          </div>
          <div class="button-wrap">
            <van-button size="small" type="default" @click="showEditRobotDialog=true">修改配置</van-button>&nbsp;
            <van-button size="small" type="danger" @click="routeTo('/robot-pay')">续费188元/月</van-button>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-dialog class="robot-config" :title="null" :show="showEditRobotDialog" :show-confirm-button="false">
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">推送开关</label><!----></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="robotConfigForm.status" />
          </div>
        </div><!----><!---->
      </div>
      <Field type="text" v-model="robotConfigForm.room" placeholder="房间ID" label="房间ID"></Field>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">播报玩法</label><!----></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <van-checkbox-group v-model="robotConfigForm.games" class="game-list-wrap">
              <van-checkbox v-for="sceneOption in sceneOptions" :name="sceneOption.text" :key="sceneOption.value" :value="sceneOption.text">{{sceneOption.text}}</van-checkbox>
            </van-checkbox-group>
          </div>
        </div><!----><!---->
      </div>
      <div class="button-wrap">
        <van-button size="small" @click="showEditRobotDialog=false">取消</van-button>
        <van-button size="small" type="primary" @click="doSaveRobotConfig">保存</van-button>
      </div>
    </van-dialog>
</template>

<style lang="less">
@import "@/app.less";

.data-cnt{
  --van-badge-background: @color2;
}

.article-content{
    text-align: left;
}

[ne-bold]{
    font-weight: 700;
}
ne-oli-i .ne-list-symbol {
    padding-right: 6px;
    font-family: @font;
}

ne-oli, ne-tli, ne-uli {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    padding-left: 2em;
}

ne-oli-i, ne-tli-i, ne-uli-i {
    min-width: 2em;
    margin-left: -2em;
    text-indent: 0;
    padding-left: 0;
    display: inline-flex;
    justify-content: flex-end;
    -moz-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    box-sizing: border-box;
    white-space: nowrap;
}

ne-oli-i .ne-list-symbol:after {
    content: ".";
}

ne-oli-c, ne-tli-c, ne-uli-c {
    text-indent: 0;
    padding-left: 0;
    min-width: 1px;
}

.ne-paragraph-spacing-relax.ne-typography-classic ne-oli, .ne-paragraph-spacing-relax.ne-typography-classic ne-tli, .ne-paragraph-spacing-relax.ne-typography-classic ne-uli {
    margin-bottom: 3.915px;
}


.data-cnt{
  --van-pagination-item-default-color: @color11;

  .van-cell__title{
    width: 6rem;
    color: @black1;
  }

  .van-field__control{
    color: #666;
  }
  .gift-record{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    flex-wrap: nowrap;
    flex-direction: row;
    padding: 0.2rem 1rem;
    .gift-time{
      width: 9rem;
      padding: 0 0.5rem;
      color: #666;
      white-space: nowrap;
    }

    .gift-scene{
      padding: 0 0.5rem;
      width: 4rem;
      white-space: nowrap;
    }

    .gift-user{
      width: 3rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .gift-name,.gift-scene{
      color: @color11;
    }
  }

  .van-color-danger{
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  .van-pagination__item{
    color: @black1;
  }
  .van-pagination__item--active{
    color: @white;
  }

  .content-wrap{
    .van-tag{
      height: 1.5rem;
      margin: 0 0.2rem;
    }
  }

}
.robot-config{
  .button-wrap{
    display: flex;
    justify-content: space-evenly;
  }

  .game-list-wrap{
    display: flex;
    flex-wrap: wrap;
    .van-checkbox{
      flex: auto;
      height: 1.5rem;
    }
  }
}

</style>
<script>
import {Button, Field, showToast} from "vant";
import store from "@/store";
import {onMounted, ref, watch} from "vue";
import ClipbordComponent from "@/components/Clipbord.vue";
import API from "@/api";
import RobotPay from "@/views/pay/RobotPay.vue";
import {useRouter} from "vue-router";
import {format} from "date-fns";

const platformDownloadUrlMap = {};

export default {
    name: 'DefaultDataDesc',
    components: {Field, RobotPay, ClipbordComponent, Button},
    props: ['dataType'],
    setup(props){
        const qqGroupId = "1031191163";
        const router = useRouter();

        const routeTo = (path) => router.push(path)

        const showBuyRobotDialog = ref(false);
        const showEditRobotDialog = ref(false);
        const userStore = store.userStore();
        const deviceId = store.userStore().getDeviceId();
        const showDownloadQRC = ref(false);
        const robotConfig = ref({
          platform: props.dataType,
          expire: format(new Date(), 'yyyy-MM-dd hh:mm:ss'),
          realStatus:false,
          status: true,
          room: null,
          games: []
        });
      const dataType = props.dataType || 'liaoyu';


      const robotConfigForm = ref(Object.assign({platform: dataType, games:[]}, robotConfig.value));

        const tabActive = ref("desc");
        const queryOptions = [
            {text: "礼物记录", value:"gift"},
            {text: "统计结果", value:"history"},
        ];
        const downloadUrl = ref(platformDownloadUrlMap[dataType]);
        const refSceneMap = ref({});
        const sceneOptions = ref([]);
        const queryType = ref("gift");
        const sceneTye = ref("");
        const searchKeyword = ref("");
        const pageData = ref({items:[], totalCount:0, pageSize: 20});
        const platformName = ref("");
        const supportRobot = ref(false);

        const robotStatus = ref(false);

        API.data.queryGameDataBase({dataType}).then((res)=>{
          if(res.success){
            sceneOptions.value = res.data.giftSceneOptions;
            refSceneMap.value = res.data.sceneMap;
            platformName.value = res.data.platformName;
            sceneTye.value = res.data.defaultGiftScene;
            supportRobot.value = res.data.supportRobot;
          }else{
            // showToast(res.errorMsg);
          }
        });

      const filterSmallVal = ref(true);

      const currentPage = ref(1);
      const user = userStore.user;

      const doQueryGift = async (value) => {
        const res = await API.data.queryGift({
          deviceId: userStore.getDeviceId(),
          scene: sceneTye.value,
          giftName: searchKeyword.value,
          dataType: dataType,
          pageNo: currentPage.value,
          minVal: filterSmallVal.value ? 100:0,
          showYoloPay: user.maxtMemberAuth.memberType === 'silver'
        });

        if(res.success){
          pageData.value = res.data;
        }else{
          showToast(res.errorMsg);
        }
      };

        const doQueryHistory = async (value) => {
          const res = await API.data.queryHistory({
            deviceId: userStore.getDeviceId(),
            scene: sceneTye.value,
            dataType: dataType,
            pageNo: currentPage.value
          });

          if(res.success){
            pageData.value = res.data;
          }else{
            showToast(res.errorMsg);
          }
        };

        const doQueryData = () => {
          if(queryType.value === "gift"){
            doQueryGift()
          }else{
            doQueryHistory()
          }
        };

      onMounted(() => {
        watch([queryType,sceneTye,searchKeyword], () => {
          doQueryData();
        });

        watch(tabActive,(value) => {
          console.log("tabActive",value);
          if(value === "query"){
            doQueryData();
          }

          if(value === "broadcast"){
            API.data.getRobotConfig({deviceId, dataType}).then(res => {
              if(res.success){
                robotConfig.value = Object.assign({platform: dataType, games:[]},robotConfig.value, res.data);
                robotConfigForm.value = Object.assign({platform: dataType, games:[]}, robotConfig.value);
              }else{
                // showToast(res.errorMsg);
              }
            });
          }
        })

        watch(currentPage, () => {
          doQueryData();
        })

      });
      return {
          robotConfigForm,
          robotConfig,
          showBuyRobotDialog,
          showEditRobotDialog,
          qqGroupId,
          deviceId,
          showDownloadQRC,
          tabActive,
          queryOptions,
          sceneOptions,
          queryType,
          sceneTye,
          searchKeyword,
          pageData,
          currentPage,
          sceneMap:refSceneMap,
          doQueryData,
          downloadUrl,
          platformName,
          filterSmallVal,
          robotStatus,
          user: userStore.user,
          supportRobot:supportRobot,
          routeTo,
        }
    },
    methods: {
      format,
      doSaveRobotConfig(){
        const _self = this;

        if(!_self.robotConfigForm.platform){
          _self.robotConfigForm.platform = _self.dataType;
        }
        API.data.doSaveRobotConfig(_self.robotConfigForm).then((res) => {
          if(res.success){
            showToast("保存成功");
            _self.showEditRobotDialog = false;
            this.robotConfig = Object.assign({}, res.data)
          }else{
            showToast(res.errorMsg);
          }
        });
      }
    }
}
</script>
